<!-- 工单咨询 -->
<template>
  <div class="workOrder">
    <div class="workOrder-wrap">
      <div class="container">
        <div>
          <el-form :inline="true"  class="demo-form-inline"  @submit.native.prevent>
            <el-form-item label="买方全称">
              <el-input v-model="formSearch.name" clearable style="width:150px"></el-input>
            </el-form-item>
            <el-form-item label="客户类型">
              <el-select v-model="formSearch.buyerType" placeholder="请选择" clearable style="width:150px" @change="search">
                <el-option
                  v-for="(value, key) in stateMap"
                  :key="key"
                  :label="value"
                  :value="key">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
            <el-button type="primary"
                      class="search-btn"
                      @click="search">查询</el-button>
            <el-button type="primary"
                      class="search-btn"
                      @click="add()">新增</el-button>
            <el-button type="primary"
                      class="search-btn"
                      @click="deleteClick()">删除</el-button>
          </el-form-item>
          </el-form>
          <el-table :data="myBuyerList" style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" align="center" width="55"></el-table-column>
            <el-table-column prop="name" label="买方全称" align="center" min-width="60"></el-table-column>
            <el-table-column label="客户类型" align="center" min-width="40">
              <template slot-scope="scope">
                {{stateMap[scope.row.buyerType]}}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="40">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small">修改</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="block">
          <el-pagination
            v-if="myBuyerList.length > 0"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="10"
            layout="total, prev, pager, next"
            :total="totalCount">
          </el-pagination>
        </div>
      </div>
    </div>
    <confirm-modal :show="isDeleteBuyer" content="是否确定删除买方？"
                   @cancel-click="isDeleteBuyer = false" @confirm-click="deleteBuyer"></confirm-modal>
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisibleOrder">
      <el-form :model="addOrderForm" :rules="rules" ref="addOrderForm" class="buyer_add">
        <el-form-item label="客户类型：" :label-width="formLabelWidth" class="el-order-height" prop="buyerType">
          <el-radio-group v-model="addOrderForm.buyerType">
            <el-radio label="1">个人买方</el-radio>
            <el-radio label="2">企业买方</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="买方全称：" :label-width="formLabelWidth" prop="name" style="margin-top:20px">
          <el-input v-model="addOrderForm.name" placeholder="请输入买方全称" auto-complete="off" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleOrder = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('addOrderForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import * as types from '../../vuex/types/type';
import confirmModal from '../common/Confirm.vue';
import myBuyerApi from '../../api/personalCenter/myBuyer';

export default {
  data() {
    return {
      isDeleteBuyer: false,
      myBuyerList: [],
      multipleSelection:[],
      needDelData:[],
      totalCount: 0,
      currentPage: 1,
      stateMap: {
        1: "个人买方",
        2: "企业买方",
      },
      dialogTitle:'新增买方',
      dialogStatus:'1',
      formSearch: {
        name: '',
        buyerType: '',
        pageNum: 1,
        pageSize: 10
      },
      dialogFormVisibleOrder: false,
      addOrderForm: {
        name: '',
        buyerType: '1'
      },
      buyerId:0,
      rules: {
        name: [{
          required: true,
          trigger: "blur",
          validator: (rule, value, callback) => {
            if (_.trim(value) === '') {
                callback(new Error('请输入买方全称'));
              } else if (value.length >= 50) {
                callback(new Error('买方全称最多输入50个字符！'));
              } else {
                callback();
              }
            }
          }],
      },
      formLabelWidth: '200px'
    };
  },
  components: {
    confirmModal
  },
  methods: {
    ...mapActions({
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setFailMessage: types.SET_FAIL_MESSAGE
    }),
    handleClick(row) {
      this.dialogTitle= "修改买方"
      this.dialogStatus= "2"
      this.buyerId = row.buyerId
      this.addOrderForm.name = row.name
      this.addOrderForm.buyerType = row.buyerType
      this.dialogFormVisibleOrder = true
    },
    search () {
      this.formSearch.pageNum = 1
      this.currentPage = 1
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.formSearch.pageNum = val
      this.fetchData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    fetchData() {
      myBuyerApi.getCrmBuyerList({
        ...this.formSearch,
        tokenId: localStorage.getItem('dl_tokenId_bl'),
        }).then(res => {
        if (res.rspcode === 1) {
          this.myBuyerList = res.data.crmCustomerList
          this.totalCount = parseFloat(res.data.crmCustomerCount)
        } else {
          this.setFailMessage({
            show: true,
            content: res.rspdesc || '获取失败'
          });
        }
      }).catch(err => {
        this.setFailMessage({
          show: true,
          content: err.rspdesc || '获取失败'
        });
      })
    },
    add(){
      this.dialogTitle= "新增买方"
      this.dialogStatus= "1"
      this.addOrderForm.name = ''
      this.addOrderForm.buyerType = '1'
      this.dialogFormVisibleOrder = true
    },
    //添加/修改买方
    addCrmBuyer() {
      if(this.dialogStatus == '1'){
        myBuyerApi.addCrmBuyer({
          ...this.addOrderForm
        }).then(res => {
          if (res.data.rspcode === 1) {
            this.setSuccessMessage({
              show: true,
              content: res.data.rspdesc || "添加成功"
            });
            setTimeout(() => {
              this.formSearch.pageNum = 1
              this.currentPage = 1
              this.fetchData()
              this.dialogFormVisibleOrder = false
            }, 500)
          } else {
            this.setFailMessage({
              show: true,
              content: res.data.rspdesc || "添加失败"
            });
          }
        }).catch(err => {
          this.setFailMessage({
            show: true,
            content: err.data.rspdesc || "添加失败"
          });
        });
      }else{
        myBuyerApi.updateCrmBuyer({
          buyerId:this.buyerId,
          ...this.addOrderForm
        }).then(res => {
          if (res.data.rspcode === 1) {
            this.setSuccessMessage({
              show: true,
              content: res.data.rspdesc || "修改成功"
            });
            setTimeout(() => {
              this.formSearch.pageNum = 1
              this.currentPage = 1
              this.fetchData()
              this.dialogFormVisibleOrder = false
            }, 500)
          } else {
            this.setFailMessage({
              show: true,
              content: res.data.rspdesc || "修改失败"
            });
          }
        }).catch(err => {
          this.setFailMessage({
            show: true,
            content: err.data.rspdesc || "修改失败"
          });
        });
      }
    },
    deleteClick() {
      if (this.multipleSelection.length === 0) {
        this.setSuccessMessage({
          show: true,
          content: "请选择需要删除的数据！"
        })
        return false
      }
      this.isDeleteBuyer = true
    },
    // 添加工单
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.addCrmBuyer()
        } else {
          return false;
        }
      });
    },
    // 删除工单
    deleteBuyer() {
      let buyerIds = this.multipleSelection.map((item) =>{
        return item.buyerId
      })
      if(buyerIds){
        buyerIds = buyerIds.toString()
      }
      myBuyerApi.delCrmBuyer({
        buyerIds: buyerIds,
        tokenId: localStorage.getItem('dl_tokenId_bl'),
      }).then(res => {
        if (res.rspcode === 1) {
          this.setSuccessMessage({
            show: true,
            content: res.rspdesc || "删除成功"
          });
          setTimeout(() => {
            window.location.reload()
          }, 500)
        } else {
          this.setFailMessage({
            show: true,
            content: res.rspdesc || "删除失败"
          });
        }
      }).catch(err => {
        this.setFailMessage({
          show: true,
          content: err.rspdesc || "删除失败"
        });
      });
    }
  },
  created() {
    this.fetchData()
  },
};
</script>
<style lang="scss">
.workOrder {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin-top: 15px;
  padding-left: 30px;
  .container {
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    padding-top: 20px;
    padding-bottom: 75px;
    background-color: #fff;
  }
}
.buyer_add .el-form-item{
  height: initial !important;
}
.buyer_add .el-order-height{
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// MyBuyer.vue?86d63fca